import { render, staticRenderFns } from "./qrAuthPage.vue?vue&type=template&id=b89a4fa6&"
import script from "./qrAuthPage.vue?vue&type=script&lang=js&"
export * from "./qrAuthPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports